import { CALCULATION_TYPE_PLANE, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK } from '../modules/calculation';

import { getItemByNid } from './calculations-helper';


function v4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}
function stripUnwantedChars(str) {
  let retVal;
  retVal = str.replace(/(?:\\[rnt]|[\r\n\t]+)+/g, '');
  retVal = retVal.trim();
  return retVal;
}

export function generateUid() {
  return v4() + v4() + v4() + v4() + v4() + v4() + v4() + v4();
}

export function isInputValueValid(value) {
  if(isNaN(value) && Number.isFinite(value)) {
    return false;
  }
  return true;
}

export function validateProsentValue(value) {
  if(value >= 0 && value <= 100) {
    return true;
  }
  return false;
}

export function changeCommaToDot(value) {
  return value.toString().replace(/,/g, '.');
}

export function getDefaultProduct(products, settings, country, type, project) {
  if(products, settings, country, type) {
    let defaultProductId;

    if(project && project.hasOwnProperty('useMarineProducts') && project.useMarineProducts) {
      const marineProducts = getProductsByType(getProductsByMarine(products.data), type);

      if(marineProducts && marineProducts[0]) {
        const marineProduct = marineProducts[0];
        const marineThickness = marineProduct['Standard-thickness'].split(',');
        return {selectedItem: marineProduct.Nid, selectedThickness: marineThickness ? marineThickness[0] : 0};
      }
    }

    switch (type) {
      case CALCULATION_TYPE_PLANE:
        defaultProductId = settings[country + '-flat-plane'];
      break;

      case CALCULATION_TYPE_PIPE:
        defaultProductId = settings[country + '-pipe'];
      break;

      case CALCULATION_TYPE_CIRCULAR_DUCT:
        defaultProductId = settings[country + '-circular-duct'];
      break;

      case CALCULATION_TYPE_RECTANGULAR_DUCT:
        defaultProductId = settings[country + '-rectangular-duct'];
      break;

      case CALCULATION_TYPE_VERTICAL_TANK:
        defaultProductId = settings[country + '-circular-tank'];
      break;

      case CALCULATION_TYPE_HORIZONTAL_TANK:
        defaultProductId = settings[country + '-circular-tank'];
      break;

      case CALCULATION_TYPE_RECTANGULAR_TANK:
        defaultProductId = settings[country + '-flat-plane'];
      break;

      default:
    }
    if(defaultProductId && defaultProductId != '') {
      const product = getItemByNid(defaultProductId, products);
      const thickness = product['Standard-thickness'].split(',');

      if(product && product['Country-where-in-usage'].includes(country)) {
        return {selectedItem: product.Nid, selectedThickness: thickness ? thickness[0] : 0};
      }
    }

    const typeAndCountryProduts = getProductsByType(getProdcutsByLanguage(products.data, country), type);
    if(typeAndCountryProduts && typeAndCountryProduts[0]) {
      const product = typeAndCountryProduts[0];
      const thickness = product['Standard-thickness'].split(',');
      return {selectedItem: product.Nid, selectedThickness: thickness ? thickness[0] : 0};
    }
  }

  return null;
}

export function getProductsByType(data, type) {
  if(!data || !type) return null;

  let AreaOfUsage;
  switch (type) {
    case CALCULATION_TYPE_PLANE:
      AreaOfUsage = 'Flat surface';
    break;

    case CALCULATION_TYPE_PIPE:
      AreaOfUsage = 'Pipe';
    break;

    case CALCULATION_TYPE_CIRCULAR_DUCT:
      AreaOfUsage = 'Circular duct';
    break;

    case CALCULATION_TYPE_RECTANGULAR_DUCT:
      AreaOfUsage = 'Rectangular duct';
    break;

    case CALCULATION_TYPE_VERTICAL_TANK:
      AreaOfUsage = 'Circular tank';
    break;

    case CALCULATION_TYPE_HORIZONTAL_TANK:
      AreaOfUsage = 'Circular tank';
    break;

    case CALCULATION_TYPE_RECTANGULAR_TANK:
      AreaOfUsage = 'Flat surface';
    break;

    default:
      AreaOfUsage = 'Flat surface';
  }
  return data.filter( item => {
    return item['Area-of-usage'].includes(AreaOfUsage);
  });
}

export function getProdcutsByLanguage(data, language) {
  if(!data || !language) return null;
  return data.filter( item => {
    if(item.hasOwnProperty('custom') && item.custom) {
      return true;
    }

    if (item.hasOwnProperty('Country-where-in-usage')) {
      return item['Country-where-in-usage'].includes(language);
    }

    return false;
  });
}

export function getProductsByMarine(data) {
  if(!data) {
    return [];
  }

  return data.filter( item => {
    if(item.hasOwnProperty('Country-where-in-usage')) {
      return item['Country-where-in-usage'].split(', ').includes('Marine');
    }
  });
}

export function getUIText(id, language, translations) {
  if(id && language && translations && translations.data) {
    const item = translations.data.find(function(item) {
      return (item['String-ID'] === id);
    });

    if(item) {
      if(item[language] === false) {
        return stripUnwantedChars(item['English']);
      } else {
        return stripUnwantedChars(item[language]);
      }
    }
  }
  return id;
}

export function buildUIStringArray(language, translations) {
  if(!language || !translations) return null;

  let retVal = {};
  for(let i = 0; i < translations.length; i++) {
    if(translations[i][language] === false) {
      retVal[translations[i]['String-ID']] = stripUnwantedChars(translations[i]['English']);
    } else {
      retVal[translations[i]['String-ID']] = stripUnwantedChars(translations[i][language]);
    }
  }

  return retVal;
}

export function getUniqueName(items, baseName) {
  var nameIndex = 1;
  if (!items)
    return baseName;
  if (items.length == 0)
    return baseName;
  if (isNameUnique(baseName, items))
    return baseName;

  while (!isNameUnique(baseName + ' ' + nameIndex, items))
  {
    nameIndex++;
  }

  return baseName + ' ' + nameIndex;
}

export function isNameUnique(productName, items) {
  for (var i = 0; i < items.length; i++)
  {
    if (items[i].hasOwnProperty('name')) {
      if (items[i].name == productName) return false;
    }
  }
  return true;
}

export function getMaterialStandard(data, id) {
  if(data) {
    return data.find( item => {
      if(item.Nid == id) {
        return item;
      }
    });
  }
  return null;
}

export function getCalculation(project) {
  const {
      calculations,
      calculationIndex
    } = project;
  return calculations ? calculations[calculationIndex] : {};
}

export function getSection(calculation) {
  const {
    sectionIndex,
    sections,
  } = calculation ? calculation : {};

  const section = sections ? sections[sectionIndex] : {};
  return section;
}

export function validateProject(project, store) {
  const {
    projects,
    products,
    materials,
    mediums,
    claddings,
    energy,

    settings,
    app,
  } = store ? store : {};

  let projectModified = false;
  let modifiedCalculations;
  if(project) {
    const {
      calculations
    } = project ? project : {};

    modifiedCalculations = calculations.map( item => {
      const {
        energyType,
        type,

        sections
      } = item ? item : {};

      let calculation = {
        ...item
      };

      let modifiedSections = sections;
      if(sections) {
        modifiedSections = sections.map( item => {
          const {
            cladding,
            content,
            material,

            insulationLayers,
            topInsulationLayers,
            sideInsulationLayers,
            bottomInsulationLayers,
          } = item ? item : {};

          let o = {
            ...item,
          };

          if(cladding != -2 && cladding != -1 && !getItemByNid(cladding, claddings)) {
            o.cladding = -2;
            projectModified = true;
          }

          if(content != -2 && content != -1 && !getItemByNid(content, mediums)) {
            const settingsType = 'Default-medium-' + getTypeForSettings(type);
            if(settings && settings[settingsType]) {
              if(getItemByNid(settings[settingsType], mediums)) {
                o.content = settings[settingsType];
                projectModified = true;
              }
            }
          }

          if(material != -2 && material != -1 && !getItemByNid(material, materials)) {
            if(settings && settings['Default-material']) {
              if(getItemByNid(settings['Default-material'], materials)) {
                o.material = settings['Default-material'];
                projectModified = true;
              }
            }
          }


          let layers = {
            insulationLayers,
            topInsulationLayers,
            sideInsulationLayers,
            bottomInsulationLayers
          };

          for(const item in layers) {
            if(item && o[item]) {
              o[item] = layers[item].map( item => {
                let newItem = {
                  ...item
                };

                if(item && item.selectedItem && !getItemByNid(item.selectedItem, products)) {
                  const settingsType = app.country + ' ' + getTypeForSettings(type);
                  if(getItemByNid(settings[settingsType], products)) {
                    newItem.selectedItem = settings[settingsType];
                    projectModified = true;
                  }
                }
                return newItem;
              });
            }
          }
          return o;
        });

        if(energyType != -2 && energyType != -1 && !getItemByNid(energyType, energy)) {
          if(settings && settings['Default-energy-source']) {
            if(getItemByNid(settings['Default-energy-source'], energy)) {
              calculation.energyType = settings['Default-energy-source'];
              projectModified = true;
            }
          }
        }

        return {
          ...calculation,
          sections: modifiedSections
        };
      }
      return modifiedCalculations;
    });
  }

  if(projectModified) {
    return {
      ...project,
      calculations: modifiedCalculations
    };
  }
  return project;
}

function getTypeForSettings(type) {
  switch (type) {
    case CALCULATION_TYPE_PLANE:
      return 'flat plane';
    break;

    case CALCULATION_TYPE_PIPE:
      return 'pipe';
    break;

    case CALCULATION_TYPE_CIRCULAR_DUCT:
      return 'duct';
    break;

    case CALCULATION_TYPE_RECTANGULAR_DUCT:
      return 'duct';
    break;

    case CALCULATION_TYPE_VERTICAL_TANK:
      return 'tank';
    break;

    case CALCULATION_TYPE_HORIZONTAL_TANK:
      return 'tank';
    break;

    case CALCULATION_TYPE_RECTANGULAR_TANK:
      return 'tank';
    break;

    default:
      return 'flat plane';
  }
}
